import type { GroupBase, StylesConfig } from 'react-select';

import { SearchableSelectType } from '../../components/inputs/searchableSelect';

import aampeTheme from '../../constants/aampeTheme';

import {
    AttributeStatus,
    FieldType,
} from '../../models/contact_attributes.model';

export const AttributeTypeOptions = [
    { value: '', label: 'All' },
    { value: FieldType.STR, label: 'String' },
    { value: FieldType.BOOL, label: 'Boolean' },
    { value: FieldType.FLOAT, label: 'Float' },
    { value: FieldType.INT, label: 'Integer' },
];

export const AttributeStatusOptions = [
    { value: '', label: 'All' },
    { value: AttributeStatus.IN_USE, label: AttributeStatus.IN_USE },
    { value: AttributeStatus.AVAILABLE, label: AttributeStatus.AVAILABLE },
    { value: AttributeStatus.INACTIVE, label: AttributeStatus.INACTIVE },
];

export const DropdownCustomStyles: StylesConfig<
    SearchableSelectType,
    boolean,
    GroupBase<SearchableSelectType>
> = {
    control: (provided) => ({
        ...provided,
        boxShadow: 'none',
        border: 'none',
        margin: aampeTheme.spacing4(0, 2),
        width: '100px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: aampeTheme.spacing4(1, 0),
        cursor: 'pointer',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: aampeTheme.spacing4(0),
    }),
    option: (provided: any, state: any) => ({
        ...provided,
        cursor: 'pointer',
        color:
            state.isFocused || state.isSelected
                ? aampeTheme.colors.white
                : aampeTheme.colors.gray950,
        backgroundColor: state.isFocused
            ? aampeTheme.colors.bordersWG01
            : state.isSelected
            ? aampeTheme.colors.solidWG02
            : aampeTheme.colors.white,
        padding: aampeTheme.spacing4(2, 4),
        whiteSpace: 'nowrap',
    }),
};

export const AttributeStatusCustomStyles = {
    control: (provided: any) => ({
        ...provided,
        border: 'none',
        boxShadow: 'none',
        width: '100%',
        cursor: 'pointer',
        background: 'inherit',
    }),
    menu: (provided: any) => ({
        ...provided,
        width: 'fit-content',
        minWidth: '100%',
    }),
    option: (provided: any, state: any) => ({
        ...provided,
        cursor: 'pointer',
        color:
            state.isFocused || state.isSelected
                ? aampeTheme.colors.white
                : aampeTheme.colors.gray950,
        backgroundColor:
            state.isFocused || state.isSelected
                ? aampeTheme.colors.solidWG02
                : aampeTheme.colors.white,
        padding: aampeTheme.spacing4(2, 4),
        whiteSpace: 'nowrap',
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        padding: '0px',
    }),
};

export const AttributeAudienceCustomStyles: StylesConfig<
    SearchableSelectType,
    boolean,
    GroupBase<SearchableSelectType>
> = {
    control: (provided) => ({
        ...provided,
        boxShadow: 'none',
        border: `1px solid ${aampeTheme.colors.bordersWG01}`,
        padding: aampeTheme.spacing4(1, 3, 1, 3),
        marginLeft: aampeTheme.spacing4(3),
        marginTop: aampeTheme.spacing4(1),
    }),
    valueContainer: (provided) => ({
        ...provided,
        display: 'flex',
        padding: aampeTheme.spacing4(1, 0),
        cursor: 'pointer',
        fontSize: aampeTheme.size.font.default,
        fontWeight: 400,
        lineHeight: '18px',
        color: aampeTheme.colors.textAccessibleWG01,
    }),
};

export const ModalHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    color: aampeTheme.colors.neutral09,
    fontSize: aampeTheme.size.font.heading,
    fontWeight: 600,
    fontStyle: 'normal',
    lineHeight: '32px',
    backgroundColor: aampeTheme.colors.white,
    padding: aampeTheme.spacing4(8, 8, 0, 8),
};

export const UserPercentageToolTip =
    '% of users who have this attribute assigned out of all users';

export const RowPerPageStyles: StylesConfig<
    SearchableSelectType,
    boolean,
    GroupBase<SearchableSelectType>
> = {
    control: (provided) => ({
        ...provided,
        boxShadow: 'none',
        border: 'none',
    }),
    valueContainer: (provided) => ({
        ...provided,
        display: 'flex',
        cursor: 'pointer',
        fontSize: aampeTheme.size.font.default,
        fontWeight: 400,
        lineHeight: '14px',
        color: aampeTheme.colors.textAccessibleWG01,
    }),
};

export const RowPerPageOptions = [
    { label: '10', value: '10' },
    { label: '15', value: '15' },
    { label: '20', value: '20' },
    { label: '50', value: '50' },
    { label: '100', value: '100' },
];
